import { useEffect, useMemo, useState } from "react";
import AlertComponent from "../../components/AlertComponent";
import {
  atualizarWhatsappSessaoStatus,
  buscarWhatsappEventoConfig,
  cancelarAgendamentoMensagem,
  cancelarDisparoMensagem,
  excluirModeloMensagem,
  enviarTesteMensagem,
  listarAgendamentosMensagem,
  listarDisparosAgendamentoMensagem,
  listarModelosMensagem,
  processarAgendamentoMensagem,
  resetarWhatsappSessao,
  salvarAgendamentoMensagem,
  salvarModeloMensagem,
  selecionarWhatsappSessao,
  solicitarWhatsappSessao,
} from "../../services/mensagemService";

const emptyModelo = {
  id: null,
  nome: "",
  corpo: "Olá {{nome}}! Faltam {{dias}} dias para {{nome_evento}} em {{data}}. Seu código é {{codigo}}. Acesse: {{url_evento}}",
  ativo: true,
};

const emptyAgendamento = {
  id: null,
  mensagemModeloId: "",
  nome: "",
  agendadaPara: "",
  publicoAlvo: 0,
  ativo: true,
};

const VARIAVEIS = [
  "{{nome}}",
  "{{nome_evento}}",
  "{{nome_espaco}}",
  "{{localizacao}}",
  "{{descricao}}",
  "{{dias}}",
  "{{data}}",
  "{{data_limite_confirmacao}}",
  "{{codigo}}",
  "{{url_evento}}",
  "{{link_evento_sem_codigo}}",
];
const PUBLICOS_ALVO = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Não confirmados" },
  { value: 2, label: "Confirmados que vão" },
  { value: 3, label: "Confirmados que recusaram" },
];

const WHATSAPP_MODO = {
  NAO_UTILIZAR: 0,
  SESSAO_EXISTENTE: 1,
  CONFIGURAR_NOVO: 2,
  SISTEMA: 3,
};

export default function MensagensPanel({ eventId, onWhatsappConfigChange }) {
  const [modelos, setModelos] = useState([]);
  const [agendamentos, setAgendamentos] = useState([]);
  const [modeloForm, setModeloForm] = useState(emptyModelo);
  const [agendamentoForm, setAgendamentoForm] = useState(emptyAgendamento);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [processandoId, setProcessandoId] = useState(null);
  const [cancelandoId, setCancelandoId] = useState(null);
  const [disparosModalAgendamento, setDisparosModalAgendamento] = useState(null);
  const [disparos, setDisparos] = useState([]);
  const [carregandoDisparos, setCarregandoDisparos] = useState(false);
  const [cancelandoDisparoId, setCancelandoDisparoId] = useState(null);
  const [testeModelo, setTesteModelo] = useState(null);
  const [testeTelefone, setTesteTelefone] = useState("");
  const [enviandoTeste, setEnviandoTeste] = useState(false);
  const [whatsappConfig, setWhatsappConfig] = useState(null);
  const [whatsappLoading, setWhatsappLoading] = useState(false);
  const [resetandoSessaoId, setResetandoSessaoId] = useState(null);
  const [novoWhatsappNome, setNovoWhatsappNome] = useState("WhatsApp do evento");

  const modeloSelecionado = useMemo(
    () => modelos.find((modelo) => modelo.id === Number(agendamentoForm.mensagemModeloId)),
    [agendamentoForm.mensagemModeloId, modelos]
  );

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  async function carregar() {
    setLoading(true);
    try {
      const [modelosRes, agendamentosRes, whatsappRes] = await Promise.all([
        listarModelosMensagem(eventId),
        listarAgendamentosMensagem(eventId),
        buscarWhatsappEventoConfig(eventId),
      ]);
      setModelos(modelosRes);
      setAgendamentos(agendamentosRes);
      atualizarWhatsappConfigLocal(whatsappRes);
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", "Erro ao carregar mensagens", { icon: "error" });
    } finally {
      setLoading(false);
    }
  }

  function atualizarModelo(campo, valor) {
    setModeloForm((current) => ({ ...current, [campo]: valor }));
  }

  function atualizarWhatsappConfigLocal(config) {
    setWhatsappConfig(config);
    onWhatsappConfigChange?.(config);
  }

  function inserirVariavel(variavel) {
    setModeloForm((current) => ({ ...current, corpo: `${current.corpo || ""}${variavel}` }));
  }

  async function salvarModelo(e) {
    e.preventDefault();
    if (!modeloForm.nome.trim() || !modeloForm.corpo.trim()) {
      AlertComponent("Campos obrigatórios", "Informe nome e mensagem do modelo", { icon: "warning" });
      return;
    }

    setSalvando(true);
    try {
      await salvarModeloMensagem(eventId, {
        id: modeloForm.id,
        nome: modeloForm.nome.trim(),
        corpo: modeloForm.corpo.trim(),
        ativo: modeloForm.ativo,
      });
      setModeloForm(emptyModelo);
      await carregar();
      AlertComponent("Sucesso", "Modelo salvo", { icon: "success", timer: 1500 });
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao salvar modelo", { icon: "error" });
    } finally {
      setSalvando(false);
    }
  }

  async function removerModelo(modelo) {
    const confirmado = await confirmarAcao(
      "Remover modelo?",
      `O modelo "${modelo.nome}" será removido.`,
      "Remover"
    );
    if (!confirmado) return;

    setSalvando(true);
    try {
      await excluirModeloMensagem(eventId, modelo.id);
      await carregar();
      AlertComponent("Removido", "Modelo removido", { icon: "success", timer: 1300 });
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao remover modelo", { icon: "error" });
    } finally {
      setSalvando(false);
    }
  }

  function editarModelo(modelo) {
    setModeloForm({
      id: modelo.id,
      nome: modelo.nome || "",
      corpo: modelo.corpo || "",
      ativo: modelo.ativo,
    });
  }

  function abrirTesteModelo(modelo) {
    setTesteModelo(modelo);
    setTesteTelefone("");
  }

  async function enviarTesteModelo(e) {
    e.preventDefault();
    if (!testeModelo) return;

    if (!testeTelefone.trim()) {
      AlertComponent("Telefone obrigatório", "Informe o número que receberá o teste", { icon: "warning" });
      return;
    }

    setEnviandoTeste(true);
    try {
      const res = await enviarTesteMensagem(eventId, testeModelo.id, testeTelefone.trim());
      setTesteModelo(null);
      setTesteTelefone("");
      AlertComponent(
        "Teste enviado",
        `Mensagem enviada para ${res.telefoneDestino} usando os dados de ${res.nomeConvidadoBase}.`,
        { icon: "success", timer: 2600 }
      );
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao enviar teste", { icon: "error" });
    } finally {
      setEnviandoTeste(false);
    }
  }

  function atualizarAgendamento(campo, valor) {
    setAgendamentoForm((current) => ({ ...current, [campo]: valor }));
  }

  async function salvarAgendamento(e) {
    e.preventDefault();
    if (!agendamentoForm.mensagemModeloId || !agendamentoForm.agendadaPara) {
      AlertComponent("Campos obrigatórios", "Selecione modelo e data de envio", { icon: "warning" });
      return;
    }

    setSalvando(true);
    try {
      await salvarAgendamentoMensagem(eventId, {
        id: agendamentoForm.id,
        mensagemModeloId: Number(agendamentoForm.mensagemModeloId),
        nome: agendamentoForm.nome.trim() || null,
        agendadaPara: agendamentoForm.agendadaPara,
        publicoAlvo: Number(agendamentoForm.publicoAlvo),
        ativo: agendamentoForm.ativo,
      });
      setAgendamentoForm(emptyAgendamento);
      await carregar();
      AlertComponent("Sucesso", "Agendamento salvo", { icon: "success", timer: 1500 });
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao salvar agendamento", { icon: "error" });
    } finally {
      setSalvando(false);
    }
  }

  function editarAgendamento(agendamento) {
    setAgendamentoForm({
      id: agendamento.id,
      mensagemModeloId: agendamento.mensagemModeloId,
      nome: agendamento.nome || "",
      agendadaPara: agendamento.agendadaPara ? agendamento.agendadaPara.slice(0, 16) : "",
      publicoAlvo: agendamento.publicoAlvo ?? 0,
      ativo: agendamento.ativo,
    });
  }

  async function cancelarAgendamento(agendamento) {
    const confirmado = await confirmarAcao(
      "Cancelar agendamento?",
      "Os disparos futuros deste agendamento serão cancelados no gateway quando possível.",
      "Cancelar envio"
    );
    if (!confirmado) return;

    setCancelandoId(agendamento.id);
    try {
      await cancelarAgendamentoMensagem(eventId, agendamento.id);
      await carregar();
      AlertComponent("Cancelado", "Agendamento cancelado", { icon: "success", timer: 1500 });
    } catch (err) {
      console.error(err);
      await carregar();
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao cancelar agendamento", { icon: "error" });
    } finally {
      setCancelandoId(null);
    }
  }

  async function enviarParaGateway(agendamento) {
    if (
      (agendamento.totalDisparos || 0) > 0 &&
      !(await confirmarAcao(
        "Enviar novamente?",
        `Já existem ${agendamento.totalDisparos} disparo(s) anteriores. Um novo envio para o gateway criará outra rodada para os convidados elegíveis.`,
        "Enviar novamente"
      ))
    ) {
      return;
    }

    setProcessandoId(agendamento.id);
    try {
      const res = await processarAgendamentoMensagem(eventId, agendamento.id);
      await carregar();
      AlertComponent(
        "Enviado para Gateway",
        `${res.agendados || 0} enviado(s), ${res.ignoradosPublicoAlvo || 0} fora do público, ${res.ignoradosSemTelefone || 0} sem telefone, ${res.falhasRetentaveis || 0} falha(s) temporária(s), ${res.falhasNaoRetentaveis || 0} falha(s) definitiva(s)`,
        { icon: "success", timer: 2800 }
      );
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao processar agendamento", { icon: "error" });
    } finally {
      setProcessandoId(null);
    }
  }

  async function abrirDisparos(agendamento) {
    setDisparosModalAgendamento(agendamento);
    await carregarDisparos(agendamento.id);
  }

  async function carregarDisparos(agendamentoId) {
    setCarregandoDisparos(true);
    try {
      const res = await listarDisparosAgendamentoMensagem(eventId, agendamentoId);
      setDisparos(res);
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao carregar disparos", { icon: "error" });
    } finally {
      setCarregandoDisparos(false);
    }
  }

  async function conectarWhatsapp() {
    setWhatsappLoading(true);
    try {
      const res = await solicitarWhatsappSessao(eventId, novoWhatsappNome.trim() || null);
      atualizarWhatsappConfigLocal(res);
      setNovoWhatsappNome("WhatsApp do evento");
      AlertComponent("Sessão criada", "Escaneie o QR Code para conectar o WhatsApp.", { icon: "success", timer: 2200 });
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao solicitar sessão de WhatsApp", { icon: "error" });
    } finally {
      setWhatsappLoading(false);
    }
  }

  async function escolherWhatsappSessao(value) {
    let whatsappModo = WHATSAPP_MODO.NAO_UTILIZAR;
    let whatsappSessaoId = null;

    if (value === "2") {
      whatsappModo = WHATSAPP_MODO.CONFIGURAR_NOVO;
    } else if (value === "3") {
      whatsappModo = WHATSAPP_MODO.SISTEMA;
    } else if (value.startsWith("1:")) {
      whatsappModo = WHATSAPP_MODO.SESSAO_EXISTENTE;
      whatsappSessaoId = Number(value.slice(2));
    }

    setWhatsappLoading(true);
    try {
      const res = await selecionarWhatsappSessao(eventId, whatsappModo, whatsappSessaoId);
      atualizarWhatsappConfigLocal(res);
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao selecionar WhatsApp", { icon: "error" });
    } finally {
      setWhatsappLoading(false);
    }
  }

  async function atualizarStatusWhatsapp() {
    const sessaoId = whatsappConfig?.sessaoSelecionada?.id;
    if (!sessaoId) return;

    setWhatsappLoading(true);
    try {
      const res = await atualizarWhatsappSessaoStatus(eventId, sessaoId);
      atualizarWhatsappConfigLocal(res);
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao atualizar WhatsApp", { icon: "error" });
    } finally {
      setWhatsappLoading(false);
    }
  }

  async function resetarSessao(sessao) {
    const confirmado = await confirmarAcao(
      "Resetar sessão?",
      `A sessão "${sessao.nome}" será desconectada e um novo QR Code será gerado.`,
      "Resetar sessão"
    );
    if (!confirmado) return;

    setResetandoSessaoId(sessao.id);
    try {
      const res = await resetarWhatsappSessao(eventId, sessao.id);
      atualizarWhatsappConfigLocal(res);
      AlertComponent("Sessão resetada", "Use o QR Code novo para conectar o WhatsApp.", { icon: "success", timer: 2200 });
    } catch (err) {
      console.error(err);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao resetar sessão", { icon: "error" });
    } finally {
      setResetandoSessaoId(null);
    }
  }

  async function cancelarDisparo(disparo) {
    const confirmado = await confirmarAcao(
      "Cancelar disparo?",
      `O disparo para ${disparo.nomeConvidado} será cancelado no gateway se ainda estiver futuro.`,
      "Cancelar disparo"
    );
    if (!confirmado) return;

    setCancelandoDisparoId(disparo.id);
    try {
      await cancelarDisparoMensagem(eventId, disparo.eventoMensagemAgendamentoId, disparo.id);
      await Promise.all([
        carregar(),
        carregarDisparos(disparo.eventoMensagemAgendamentoId),
      ]);
      AlertComponent("Cancelado", "Disparo cancelado", { icon: "success", timer: 1500 });
    } catch (err) {
      console.error(err);
      await carregarDisparos(disparo.eventoMensagemAgendamentoId);
      AlertComponent("Erro", err.response?.data?.mensagem || "Erro ao cancelar disparo", { icon: "error" });
    } finally {
      setCancelandoDisparoId(null);
    }
  }

  const sessoesWhatsapp = whatsappConfig?.sessoes || [];
  const sessaoSelecionada = whatsappConfig?.sessaoSelecionada || null;
  const whatsappModo = Number(whatsappConfig?.whatsappModo ?? WHATSAPP_MODO.NAO_UTILIZAR);
  const podeEscolherWhatsapp = !!whatsappConfig?.podeEscolherWhatsapp;
  const podeSolicitarNovaSessao = !!whatsappConfig?.podeSolicitarNovaSessao;
  const whatsappSelectValue = whatsappModo === WHATSAPP_MODO.SESSAO_EXISTENTE
    ? `1:${whatsappConfig?.whatsappSessaoId || ""}`
    : String(whatsappModo);
  const mostrarCriacaoSessao = podeSolicitarNovaSessao && whatsappModo === WHATSAPP_MODO.CONFIGURAR_NOVO;
  const qrCodeSrc = obterQrCodeSrc(sessaoSelecionada);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="w-8 h-8 border-2 border-violet-300 border-t-violet-600 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <>
    <section className="mb-6 bg-white rounded-xl shadow border overflow-hidden">
      <div className="px-5 py-4 border-b border-slate-100 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div>
          <h2 className="text-base font-semibold text-slate-800">WhatsApp do evento</h2>
          <p className="text-xs text-slate-500 mt-1">As mensagens deste evento usam a configuração escolhida para ele.</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          {mostrarCriacaoSessao && (
            <>
              <input
                type="text"
                value={novoWhatsappNome}
                onChange={(e) => setNovoWhatsappNome(e.target.value)}
                disabled={whatsappLoading}
                className="w-full sm:w-56 rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
                placeholder="Nome da conexão"
              />
              <button
                type="button"
                onClick={conectarWhatsapp}
                disabled={whatsappLoading}
                className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-60"
              >
                {whatsappLoading ? "Aguarde..." : "Conectar WhatsApp"}
              </button>
            </>
          )}
          <button
            type="button"
            onClick={atualizarStatusWhatsapp}
            disabled={whatsappLoading || !sessaoSelecionada}
            className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-60"
          >
            Atualizar status
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_220px] gap-5 p-5">
        <div className="space-y-4">
          {podeEscolherWhatsapp ? (
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">WhatsApp utilizado neste evento</label>
              <select
                value={whatsappSelectValue}
                onChange={(e) => escolherWhatsappSessao(e.target.value)}
                disabled={whatsappLoading}
                className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
              >
                <option value="0">Não utilizar</option>
                <option value="3">WhatsApp do sistema</option>
                {sessoesWhatsapp.map((sessao) => (
                  <option key={sessao.id} value={`1:${sessao.id}`}>
                    {sessao.nome}{sessao.telefone ? ` - ${sessao.telefone}` : ""}{sessao.dono ? "" : " - compartilhado"}
                  </option>
                ))}
                <option value="2">Configurar Novo WhatsApp</option>
              </select>
            </div>
          ) : whatsappModo === WHATSAPP_MODO.CONFIGURAR_NOVO ? (
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4 text-sm text-emerald-800">
              Este evento está aguardando a conexão de um novo WhatsApp.
            </div>
          ) : null}

          <div className="rounded-xl bg-slate-50 p-4">
            {sessaoSelecionada ? (
              <div className="space-y-2">
                <div className="flex flex-wrap items-center gap-2">
                  <p className="text-sm font-semibold text-slate-800">{sessaoSelecionada.nome}</p>
                  <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${sessaoSelecionada.conectado ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
                    {sessaoSelecionada.conectado ? "Conectado" : sessaoSelecionada.status || "Aguardando"}
                  </span>
                  {!sessaoSelecionada.dono && (
                    <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-500">
                      Sessão de outro administrador
                    </span>
                  )}
                </div>
                <p className="text-sm text-slate-500">
                  {sessaoSelecionada.telefone ? `Telefone conectado: ${sessaoSelecionada.telefone}` : "Escaneie o QR Code para concluir a conexão."}
                </p>
              </div>
            ) : whatsappModo === WHATSAPP_MODO.CONFIGURAR_NOVO ? (
              <p className="text-sm text-slate-500">Clique em “Conectar WhatsApp” para gerar o QR Code deste evento.</p>
            ) : whatsappModo === WHATSAPP_MODO.SISTEMA ? (
              <p className="text-sm text-slate-500">Os envios usarão o WhatsApp configurado no gateway do sistema.</p>
            ) : whatsappModo === WHATSAPP_MODO.NAO_UTILIZAR ? (
              <p className="text-sm text-slate-500">O WhatsApp está desativado para este evento.</p>
            ) : (
              <p className="text-sm text-slate-500">Selecione uma sessão ativa de WhatsApp antes de enviar mensagens.</p>
            )}
          </div>

          {sessoesWhatsapp.length > 0 && (
            <div className="rounded-xl border border-slate-200 divide-y divide-slate-100 overflow-hidden">
              {sessoesWhatsapp.map((sessao) => (
                <div key={sessao.id} className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-3">
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-slate-800 truncate">{sessao.nome}</p>
                    <p className="text-xs text-slate-500">
                      {sessao.telefone || "Sem telefone conectado"} · {sessao.conectado ? "Conectado" : sessao.status || "Aguardando"}
                    </p>
                  </div>
                  <button
                    type="button"
                    onClick={() => resetarSessao(sessao)}
                    disabled={resetandoSessaoId === sessao.id || whatsappLoading}
                    className="rounded-lg border border-amber-200 px-3 py-1.5 text-xs font-semibold text-amber-700 hover:bg-amber-50 disabled:opacity-60"
                  >
                    {resetandoSessaoId === sessao.id ? "Resetando..." : "Resetar sessão"}
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="flex items-center justify-center rounded-xl border border-slate-200 bg-slate-50 p-4 min-h-[220px]">
          {qrCodeSrc ? (
            <img src={qrCodeSrc} alt="QR Code do WhatsApp" className="h-44 w-44 rounded-lg bg-white object-contain p-2 shadow-sm" />
          ) : (
            <div className="text-center text-sm text-slate-400">
              {whatsappModo === WHATSAPP_MODO.SISTEMA
                ? "WhatsApp do sistema"
                : sessaoSelecionada?.conectado ? "Sessão conectada" : "QR Code indisponível"}
            </div>
          )}
        </div>
      </div>
    </section>
    <div className="grid grid-cols-1 xl:grid-cols-[420px_minmax(0,1fr)] gap-6">
      <div className="space-y-6">
        <form onSubmit={salvarModelo} className="bg-white p-5 rounded-xl shadow border space-y-4">
          <div>
            <h2 className="text-base font-semibold text-slate-800">Modelo de mensagem</h2>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Nome</label>
            <input
              type="text"
              value={modeloForm.nome}
              onChange={(e) => atualizarModelo("nome", e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
              disabled={salvando}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Mensagem</label>
            <textarea
              rows={7}
              value={modeloForm.corpo}
              onChange={(e) => atualizarModelo("corpo", e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400 resize-y"
              disabled={salvando}
            />
            <div className="mt-2 flex flex-wrap gap-2">
              {VARIAVEIS.map((variavel) => (
                <button
                  key={variavel}
                  type="button"
                  onClick={() => inserirVariavel(variavel)}
                  className="rounded-lg border border-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-600 hover:bg-slate-50"
                  disabled={salvando}
                >
                  {variavel}
                </button>
              ))}
            </div>
          </div>
          <label className="flex items-center gap-2 text-sm text-slate-700">
            <input
              type="checkbox"
              checked={modeloForm.ativo}
              onChange={(e) => atualizarModelo("ativo", e.target.checked)}
              disabled={salvando}
            />
            Ativo
          </label>
          <div className="flex justify-end gap-2">
            {modeloForm.id && (
              <button
                type="button"
                onClick={() => setModeloForm(emptyModelo)}
                className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-50"
                disabled={salvando}
              >
                Cancelar
              </button>
            )}
            <button
              type="submit"
              className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60"
              disabled={salvando}
            >
              {salvando ? "Salvando..." : modeloForm.id ? "Atualizar modelo" : "Criar modelo"}
            </button>
          </div>
        </form>

        <form onSubmit={salvarAgendamento} className="bg-white p-5 rounded-xl shadow border space-y-4">
          <h2 className="text-base font-semibold text-slate-800">Agendamento</h2>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Modelo</label>
            <select
              value={agendamentoForm.mensagemModeloId}
              onChange={(e) => atualizarAgendamento("mensagemModeloId", e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
              disabled={salvando}
            >
              <option value="">Selecione</option>
              {modelos.map((modelo) => (
                <option key={modelo.id} value={modelo.id}>
                  {modelo.nome}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Nome</label>
            <input
              type="text"
              value={agendamentoForm.nome}
              onChange={(e) => atualizarAgendamento("nome", e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
              placeholder={modeloSelecionado?.nome || "Opcional"}
              disabled={salvando}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Data e hora</label>
            <input
              type="datetime-local"
              value={agendamentoForm.agendadaPara}
              onChange={(e) => atualizarAgendamento("agendadaPara", e.target.value)}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
              disabled={salvando}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Enviar para</label>
            <select
              value={agendamentoForm.publicoAlvo}
              onChange={(e) => atualizarAgendamento("publicoAlvo", Number(e.target.value))}
              className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
              disabled={salvando}
            >
              {PUBLICOS_ALVO.map((publico) => (
                <option key={publico.value} value={publico.value}>
                  {publico.label}
                </option>
              ))}
            </select>
          </div>
          <label className="flex items-center gap-2 text-sm text-slate-700">
            <input
              type="checkbox"
              checked={agendamentoForm.ativo}
              onChange={(e) => atualizarAgendamento("ativo", e.target.checked)}
              disabled={salvando}
            />
            Ativo
          </label>
          <div className="flex justify-end gap-2">
            {agendamentoForm.id && (
              <button
                type="button"
                onClick={() => setAgendamentoForm(emptyAgendamento)}
                className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-50"
                disabled={salvando}
              >
                Cancelar
              </button>
            )}
            <button
              type="submit"
              className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60"
              disabled={salvando || modelos.length === 0}
            >
              {salvando ? "Salvando..." : agendamentoForm.id ? "Atualizar agendamento" : "Criar agendamento"}
            </button>
          </div>
        </form>
      </div>

      <div className="space-y-6 min-w-0">
        <section className="bg-white rounded-xl shadow border overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-100">
            <h2 className="text-base font-semibold text-slate-800">Modelos cadastrados</h2>
          </div>
          {modelos.length === 0 ? (
            <div className="px-5 py-10 text-sm text-slate-500 text-center">Nenhum modelo cadastrado.</div>
          ) : (
            <div className="divide-y divide-slate-100">
              {modelos.map((modelo) => (
                <div key={modelo.id} className="p-5">
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-3">
                    <div className="min-w-0">
                      <div className="flex items-center gap-2">
                        <p className="font-semibold text-slate-800">{modelo.nome}</p>
                        <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${modelo.ativo ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>
                          {modelo.ativo ? "Ativo" : "Inativo"}
                        </span>
                      </div>
                      <p className="mt-2 whitespace-pre-wrap text-sm text-slate-500">{modelo.corpo}</p>
                    </div>
                    <div className="flex gap-2 shrink-0">
                      <button type="button" onClick={() => abrirTesteModelo(modelo)} className="rounded-lg bg-emerald-50 px-3 py-1.5 text-xs font-semibold text-emerald-700 hover:bg-emerald-100">
                        Testar
                      </button>
                      <button type="button" onClick={() => editarModelo(modelo)} className="rounded-lg bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-200">
                        Editar
                      </button>
                      <button type="button" onClick={() => removerModelo(modelo)} className="rounded-lg bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-600 hover:bg-red-100">
                        Remover
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        <section className="bg-white rounded-xl shadow border overflow-hidden">
          <div className="px-5 py-4 border-b border-slate-100">
            <h2 className="text-base font-semibold text-slate-800">Agendamentos</h2>
          </div>
          {agendamentos.length === 0 ? (
            <div className="px-5 py-10 text-sm text-slate-500 text-center">Nenhum agendamento cadastrado.</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[860px]">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-100">
                    <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">Agendamento</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">Modelo</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">Público</th>
                    <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase">Disparos</th>
                    <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase">Status</th>
                    <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase">Ações</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {agendamentos.map((agendamento) => (
                    <tr key={agendamento.id}>
                      <td className="px-4 py-4">
                        <p className="text-sm font-semibold text-slate-800">{agendamento.nome || agendamento.modelo?.nome || "Mensagem"}</p>
                        <p className="text-xs text-slate-500">{formatarData(agendamento.agendadaPara)}</p>
                      </td>
                      <td className="px-4 py-4 text-sm text-slate-600">{agendamento.modelo?.nome || "-"}</td>
                      <td className="px-4 py-4 text-sm text-slate-600">{agendamento.publicoAlvoNome || obterPublicoAlvoNome(agendamento.publicoAlvo)}</td>
                      <td className="px-4 py-4 text-center">
                        <p className="text-sm font-semibold text-slate-700">{agendamento.totalDisparos || 0}</p>
                        {(agendamento.totalDisparosCancelados || agendamento.totalDisparosGateway) ? (
                          <p className="text-[11px] text-slate-500">
                            {agendamento.totalDisparosCancelados || 0} cancelado(s) · {agendamento.totalDisparosGateway || 0} no gateway
                          </p>
                        ) : null}
                      </td>
                      <td className="px-4 py-4 text-center">
                        <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${obterClasseStatusAgendamento(agendamento.statusEnvio, agendamento.ativo)}`}>
                          {agendamento.statusEnvio || (agendamento.ativo ? "Ativo" : "Inativo")}
                        </span>
                      </td>
                      <td className="px-4 py-4">
                        <div className="flex justify-center gap-2">
                          <button
                            type="button"
                            onClick={() => enviarParaGateway(agendamento)}
                            disabled={!agendamento.ativo || processandoId === agendamento.id || cancelandoId === agendamento.id}
                            className="rounded-lg bg-violet-50 px-3 py-1.5 text-xs font-semibold text-violet-700 hover:bg-violet-100 disabled:opacity-60"
                          >
                            {processandoId === agendamento.id ? "Enviando..." : "Enviar para Gateway"}
                          </button>
                          <button type="button" onClick={() => abrirDisparos(agendamento)} className="rounded-lg bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-700 hover:bg-blue-100">
                            Disparos
                          </button>
                          <button type="button" onClick={() => editarAgendamento(agendamento)} disabled={!agendamento.ativo || cancelandoId === agendamento.id} className="rounded-lg bg-slate-100 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-200 disabled:opacity-60">
                            Editar
                          </button>
                          <button type="button" onClick={() => cancelarAgendamento(agendamento)} disabled={!agendamento.podeCancelar || cancelandoId === agendamento.id} className="rounded-lg bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-600 hover:bg-red-100 disabled:opacity-60">
                            {cancelandoId === agendamento.id ? "Cancelando..." : "Cancelar envio"}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </div>
    {testeModelo && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4 py-6">
        <form onSubmit={enviarTesteModelo} className="w-full max-w-lg rounded-xl bg-white shadow-2xl border border-slate-200">
          <div className="border-b border-slate-100 px-5 py-4">
            <h2 className="text-base font-semibold text-slate-800">Testar mensagem</h2>
            <p className="text-xs text-slate-500">{testeModelo.nome}</p>
          </div>
          <div className="space-y-4 px-5 py-4">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Telefone de destino</label>
              <input
                type="tel"
                value={testeTelefone}
                onChange={(e) => setTesteTelefone(e.target.value)}
                className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-slate-400"
                placeholder="Ex.: 5531999999999"
                disabled={enviandoTeste}
                autoFocus
              />
            </div>
            <p className="text-xs text-slate-500">
              O teste usa os dados do primeiro convidado cadastrado para preencher as variáveis, mas envia para este número.
            </p>
          </div>
          <div className="flex justify-end gap-2 border-t border-slate-100 px-5 py-4">
            <button
              type="button"
              onClick={() => {
                setTesteModelo(null);
                setTesteTelefone("");
              }}
              className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-50"
              disabled={enviandoTeste}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="rounded-lg bg-emerald-600 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-60"
              disabled={enviandoTeste}
            >
              {enviandoTeste ? "Enviando..." : "Enviar teste"}
            </button>
          </div>
        </form>
      </div>
    )}
    {disparosModalAgendamento && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4 py-6">
        <div className="w-full max-w-5xl max-h-[88vh] overflow-hidden rounded-xl bg-white shadow-2xl border border-slate-200">
          <div className="flex items-start justify-between gap-4 border-b border-slate-100 px-5 py-4">
            <div>
              <h2 className="text-base font-semibold text-slate-800">Disparos</h2>
              <p className="text-xs text-slate-500">{disparosModalAgendamento.nome || disparosModalAgendamento.modelo?.nome || "Mensagem"}</p>
            </div>
            <button
              type="button"
              onClick={() => {
                setDisparosModalAgendamento(null);
                setDisparos([]);
              }}
              className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-50"
            >
              Fechar
            </button>
          </div>
          <div className="max-h-[70vh] overflow-auto">
            {carregandoDisparos ? (
              <div className="flex items-center justify-center py-12">
                <div className="w-7 h-7 border-2 border-blue-200 border-t-blue-600 rounded-full animate-spin" />
              </div>
            ) : disparos.length === 0 ? (
              <div className="px-5 py-10 text-center text-sm text-slate-500">Nenhum disparo enviado para o gateway.</div>
            ) : (
              <table className="w-full min-w-[900px]">
                <thead>
                  <tr className="bg-slate-50 border-b border-slate-100">
                    <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">Convidado</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">Agendado para</th>
                    <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 uppercase">Enviado ao gateway</th>
                    <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase">Status</th>
                    <th className="px-4 py-3 text-center text-xs font-semibold text-slate-500 uppercase">Ações</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {disparos.map((disparo) => (
                    <tr key={disparo.id}>
                      <td className="px-4 py-4">
                        <p className="text-sm font-semibold text-slate-800">{disparo.nomeConvidado}</p>
                        <p className="text-xs text-slate-500">{disparo.telefoneDestino || "-"}</p>
                      </td>
                      <td className="px-4 py-4 text-sm text-slate-600">{formatarDataUtc(disparo.agendadaParaUtc)}</td>
                      <td className="px-4 py-4 text-sm text-slate-600">{formatarDataUtc(disparo.enviadoAoGatewayEmUtc)}</td>
                      <td className="px-4 py-4 text-center">
                        <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${obterClasseStatusDisparo(disparo.status)}`}>
                          {formatarStatusDisparo(disparo.status)}
                        </span>
                      </td>
                      <td className="px-4 py-4 text-center">
                        <button
                          type="button"
                          onClick={() => cancelarDisparo(disparo)}
                          disabled={!disparoPodeCancelar(disparo) || cancelandoDisparoId === disparo.id}
                          className="rounded-lg bg-red-50 px-3 py-1.5 text-xs font-semibold text-red-600 hover:bg-red-100 disabled:opacity-60"
                        >
                          {cancelandoDisparoId === disparo.id ? "Cancelando..." : "Cancelar"}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    )}
    </>
  );
}

function obterPublicoAlvoNome(value) {
  return PUBLICOS_ALVO.find((publico) => publico.value === Number(value))?.label || "Todos";
}

function formatarData(value) {
  if (!value) return "-";

  return new Date(value).toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function formatarDataUtc(value) {
  const data = parseDataUtc(value);
  if (!data) return "-";

  return data.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function parseDataUtc(value) {
  if (!value) return null;
  if (value instanceof Date) return value;

  const texto = String(value);
  const possuiFuso = /(?:z|[+-]\d{2}:?\d{2})$/i.test(texto);
  return new Date(possuiFuso ? texto : `${texto}Z`);
}

function obterClasseStatusAgendamento(status, ativo) {
  if (status === "Cancelado") {
    return "bg-red-50 text-red-700";
  }

  if (status === "Processado no gateway") {
    return "bg-blue-50 text-blue-700";
  }

  if (status === "Aguardando envio") {
    return "bg-amber-50 text-amber-700";
  }

  if (status === "Falha temporária" || status === "Falha definitiva") {
    return "bg-orange-50 text-orange-700";
  }

  return ativo ? "bg-emerald-50 text-emerald-700" : "bg-slate-100 text-slate-500";
}

function obterQrCodeSrc(sessao) {
  const qrCode = sessao?.qrCodeBase64?.trim();
  if (!qrCode) return null;
  if (qrCode.startsWith("data:image/") || qrCode.startsWith("http://") || qrCode.startsWith("https://")) {
    return qrCode;
  }

  return `data:image/png;base64,${qrCode}`;
}

function formatarStatusDisparo(status) {
  switch (status) {
    case "Agendado":
      return "Enviado ao gateway";
    case "Cancelado":
      return "Cancelado";
    case "FalhaRetentavel":
      return "Falha temporária";
    case "FalhaNaoRetentavel":
      return "Falha definitiva";
    default:
      return status || "Pendente";
  }
}

function obterClasseStatusDisparo(status) {
  switch (status) {
    case "Agendado":
      return "bg-blue-50 text-blue-700";
    case "Cancelado":
      return "bg-red-50 text-red-700";
    case "FalhaRetentavel":
    case "FalhaNaoRetentavel":
      return "bg-orange-50 text-orange-700";
    default:
      return "bg-amber-50 text-amber-700";
  }
}

async function confirmarAcao(title, text, confirmButtonText) {
  const result = await AlertComponent(
    title,
    text,
    {
      icon: "warning",
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      reverseButtons: true,
      focusCancel: true,
    },
    null,
    false,
    confirmButtonText
  );

  return result.isConfirmed;
}

function disparoPodeCancelar(disparo) {
  if (!disparo?.podeCancelar) {
    return false;
  }

  const agendadaPara = parseDataUtc(disparo.agendadaParaUtc);
  return Boolean(agendadaPara && agendadaPara > new Date());
}
